<template>
  <div id="Packages" class="package-wrapper">
  	<div class="add-query">
    
    
    <b-container fluid class="package-container">
        <b-row id="buy_package" v-if="show_buy_package_screen">
          <b-col lg="12">
            <h4>You have {{calculated_credits}} Credits Available!</h4>
          </b-col>
          <b-col lg="12">
            <p>You can choose one of the plans below to purchase:</p>  
          </b-col>
          
          <b-col lg="4" v-for="(a_package,index) in packages" :key="a_package.id">
            <div class="package-item">
              <h3 class="package-head">{{a_package.name}}</h3>
              <b-row>
                <!-- <b-col lg="6"> -->
                  <b>Doubts: </b> <span>{{a_package.credits}}</span>
                <!-- </b-col> -->
                <!-- <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col> -->
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="btn query-btn" variant="primary" @click="buy_package(index)">Buy for ₹{{a_package.cost}}</b-button>
            </div>
          </b-col>
          <!-- <b-col lg="4">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="6">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col>
          <b-col lg="4">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="6">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col>
          <b-col lg="4">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="6">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col>
          <b-col lg="4">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="6">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col>
          <b-col lg="4">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="6">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="6">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b>Add on:</b>
              <p>- Tables upto 250</p>
              <p>- Squares upto 250</p>
              <p>- Cubes upto 250</p>
              <p>- Unit Sheet</p>
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col> -->
        </b-row>
        <b-row id="transaction_success" v-if="transaction_success">
          <b-col>
            <h4>Transaction Successful! You have {{calculated_credits}} Credits available.</h4>
            <p>We have received your payment, and now you can ask your doubts at your ease!</p>
            <p>Here is a summary of your transaction:</p>
            <table>
              <tr>
                <td>Payment Id:</td>
                <td>{{transaction_summary.payment_id}}</td>
              </tr>
              <tr>
                <td>Package Name:</td>
                <td>{{selected_package.name}}</td>
              </tr>
              <tr>
                <td>Credits:</td>
                <td>{{selected_package.credits}}</td>
              </tr>
            </table><br>
            <p>Thanks a lot, we are awaiting your doubts, Go ahead!</p>
            <b-button class="btn btn-blue" to="/dashboard/add-doubt">Ask a Doubt</b-button>

          </b-col>
        </b-row>
      </b-container>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Packages',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle:'',
        selected: null,
        doubt:''
      },
      show_buy_package_screen:true, //show buy_package screen by default
      selected_package:{},
      buy_package_id:'',
      transaction_success:false, // show transaction success screen
      transaction_summary: {
        payment_id:'',
        transaction:''
      }
    }
  },
  computed: {
    packages: function() {
      return this.$store.getters.get_packages;
    },
    user_info: function() {
      return this.$store.getters.user;
    },
    calculated_credits: function() {
      if(this.user_info.credits.credit != null) {
        if(this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit)
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  },
  created: async function() {
    this.$store.commit('setLoader',true);
    try {
      var action = await this.$store.dispatch('fetch_packages');
      this.$store.commit('setLoader',false);
    } catch(ex) {
      this.$toasted.show('There was an error, please refresh!',{type:'success'});
    }
    
  },
  methods: {
    onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    async capture_payment(razorpay_response) {
      var razorpay_payment_id = razorpay_response.razorpay_payment_id;
      
      try {
        this.$store.commit('setLoader',true);
        var result = await this.$store.dispatch('capture_payment',{razorpay_payment_id:razorpay_payment_id,package_id:this.buy_package_id});

        this.transaction_summary = result.data.data;

        var result2 = await this.$store.dispatch('fetch_me');

        this.show_buy_package_screen = false;
        this.transaction_success = true;

        this.$store.commit('setLoader',false);


      } catch(ex) {
        this.$toasted.show("We had a problem processing your transaction, please try again!");
      }
    },
    buy_package(package_index) {
      console.log(package_index);
      this.selected_package = this.packages[package_index];
      this.buy_package_id = this.selected_package.id;
      var rzp_options = {
          key: "rzp_test_5KUgaV57XyIaIU",
          amount: this.selected_package.cost * 100,
          name: "QdsPro",
          description: "Buy Package " + this.selected_package.name,
          handler: this.capture_payment,
          theme: {
              color: "#262f3c"
          }
      };
      
      var rzp1 = new Razorpay(rzp_options);
      rzp1.open();

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-query h2 {
  color:#262e3b;
  text-transform: uppercase;
  font-weight: bold;
  padding:20px 0;
  border-bottom:1px solid #e5e5e5;
  width:90%;
  margin:0 auto;
}

.package-head {
  text-align:center;
  border-bottom:1px solid #efefef;
  color:#AACF37;
  font-weight:bold;
}
.package-item a {
  display:block;
  width:90%;
  margin:0 auto;
  border-radius:10px;
}
.package-item p {
  margin:0;
}
.package-item .row,.package-item a {
  margin-top:20px;
  margin-bottom:20px;
}
.package-container .col-lg-4 {
  margin-bottom:30px;
}

@media screen and (min-width: 1280px) {
  .package-container {
    width:90%;
    margin:50px auto 0;
} 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Packages.vue